import Ulcd from './src/main.vue';

/* istanbul ignore next */
Ulcd.install = function(Vue) {
  Vue.component(Ulcd.name, Ulcd);
};

export default Ulcd;
